export * from '../src/composites/wui-network-image/index.js';
//# sourceMappingURL=wui-network-image.js.map